<!--
  @Description: 购票
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div>
    <div class="skeleton-warpper" v-if="pageLoading">
      <van-skeleton title :row="5" />
    </div>
    <div class="main-container" v-else>
      <page-header>{{'预注册' | dealLanguage('Pre-registration')}}</page-header>
      <div class="center-wrapper">
        <TopTip></TopTip>
        <div class="form-view">
          <Form ref="current-form" :model="currentForm" :rules="ruleValidate2">
            <div class="view-title">
              <div class="title">{{'个人信息' | dealLanguage('Personal Information')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
              <Input type="text" v-model="currentForm.name" :placeholder="'请填写姓名' | dealLanguage('Please fill in your name')"></Input>
            </FormItem>
            <FormItem prop="mobile" :label="'手机号码' | dealLanguage('Phone Number')" v-if="language == 'zh'">
              <div class="mobile-ipt">
                <span :class="['area-number']" style="background-color: #f0f0f0;">+{{currentForm.mobileAreaCode}} &gt;</span>
                <Input type="text" v-model="currentForm.mobile" disabled :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem prop="email" :label="'邮箱' | dealLanguage('E-mail')">
              <Input type="text" v-model="currentForm.email" :placeholder="'请填写邮箱' | dealLanguage('Please fill in your email')"></Input>
            </FormItem>
            <Row :gutter="10">
              <Col span="12">
              <FormItem prop="compName" :label="'公司' | dealLanguage('Company Name')">
                <div class="input-tag">
                  <AutoComplete v-model="entityKeyword" :placeholder="!currentForm.entityId ? filter.dealLanguage('请搜索并选择公司', 'Please search and select a company') : ''" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity">
                    <Option v-for="item in entityList" :value="item.id" :key="item.id">
                      <div class="title">
                        {{item.shortName}}
                      </div>
                      <div class="desc">
                        {{item.description}}
                      </div>
                    </Option>
                  </AutoComplete>
                  <div class="tag-div" v-if="currentForm.entityId">
                    <Tag closable @on-close="handleClose" color="blue">{{currentForm.compName}}</Tag>
                  </div>
                </div>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
                <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位' | dealLanguage('Please fill in the position')"></Input>
              </FormItem>
              </Col>
            </Row>
            <FormItem prop="addressId" :label="'地区' | dealLanguage('Country&City')">
              <div class="ivu-input custom-ipt" @click="handleShowAddress">
                <span class="placeholder-span" v-if="!currentForm.addressId">{{'请选择所在地区' | dealLanguage('Please Select')}}</span>
                <span class="txt" v-else>{{currentForm.addressId | addressDtoDeal(addressDtoList, 3, '/', language == 'zh' ? 'name' : 'enName')}}</span>
              </div>
            </FormItem>
            <FormItem prop="companyProfile" :label="'公司性质' | dealLanguage('Company Profile')">
              <RadioGroup v-model="currentForm.companyProfile" @on-change="handleChangeCompanyProfile">
                <Radio :label="item" v-for="item,index in companyProfileList" :key="index"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="companyprofileother" v-if="companyprofileother">
              <Input type="text" v-model="currentForm.companyprofileother" :placeholder="'其他，请填写' | dealLanguage('Others, please specify')"></Input>
            </FormItem>
            <div class="view-title">
              <div class="title">{{'参会信息' | dealLanguage('Meeting Registration')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="concurrent2" :label="'您需要参加哪些论坛？（多选）' | dealLanguage('Select Forums to Attend (Multiple choices allowed)')">
              <CheckboxGroup v-model="currentForm.concurrent2">
                <p style="font-weight: 600">{{'9月12日下午' | dealLanguage('On the afternoon of September 12th')}}</p>
                <Checkbox :label="item" v-for="item,index in concurrentList.slice(0, 5)" :key="index"></Checkbox>
                <p style="font-weight: 600">{{'9月13日上午' | dealLanguage('On the morning of September 13th')}}</p>
                <Checkbox :label="item" v-for="item,index in concurrentList.slice(5, 12)" :key="index"></Checkbox>
                <p style="font-weight: 600">{{'9月13日下午' | dealLanguage('On the afternoon of September 13th')}}</p>
                <Checkbox :label="item" v-for="item,index in concurrentList.slice(12)" :key="index"></Checkbox>
              </CheckboxGroup>
            </FormItem>
            <FormItem prop="need2" :label="'您参加本次大会最想实现的需求是（请选出最重要的3项）' | dealLanguage('Primary Goals for Attending (Select top 3)')">
              <CheckboxGroup v-model="currentForm.need2" @on-change="handleChangeNeed">
                <Checkbox :label="item" v-for="item,index in needList" :key="index"></Checkbox>
              </CheckboxGroup>
            </FormItem>
            <FormItem prop="need2other" v-if="need2other">
              <Input type="text" v-model="currentForm.need2other" :placeholder="'其他，请填写' | dealLanguage('Others，please specify')"></Input>
            </FormItem>
            <FormItem prop="service2" :label="'您希望从9月12-13日的CSGCT大会中优先获取哪些资源或信息？' | dealLanguage('What you perfer to acquire from the CSGCT conference on Sep 12- 13')">
              <RadioGroup v-model="currentForm.service2">
                <Radio :label="item" v-for="item,index in serviceList" :key="index"></Radio>
              </RadioGroup>
            </FormItem>
            <div class="view-title">
              <div class="title">{{'门票信息' | dealLanguage('Event Options')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="activityTicketName" label="您是否希望参与以下活动？" v-if="language == 'zh'">
              <RadioGroup v-model="currentForm.activityTicketName">
                <Radio :label="item" v-for="item,index in activityTicketList" :key="index"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="activityTicketNameEn" label="Event Options" v-else>
              <RadioGroup v-model="currentForm.activityTicketNameEn">
                <Radio :label="item" v-for="item,index in activityTicketListEn" :key="index"></Radio>
              </RadioGroup>
              <div class="option-tips">
                included all Activities & transportation & Accommodation):<br />
                - 2-Day Meeting Pass + 2-Day lunch + Welcome Dinner + Premium Cocktail Reception<br />
                - TOP Hospital Visit & exchange<br />
                - Global CGT Leaders Ascend the Great Wall<br />
                - CGT-Specialized Enterprise & Park Tours<br />
                - Hainan Boao Lecheng Pilot Zone Healthcare Immersion Delegation‌<br />
                - ‌Medical Escort Interpreter<br />
              </div>
            </FormItem>
            <div class="view-title">
              <div class="title">{{'请选择门票类型' | dealLanguage('Please select the ticket type')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="activityTicketId">
              <div class="ticket-list">
                <RadioGroup v-model="currentForm.activityTicketId" @on-change="handleSeletTicket">
                  <Radio :label="item.id" v-for="item,index in ticketList" :key="index">
                    <div class="ticket-item ticket-container">
                      <div class="ticket-item-top">
                        <div class="ticket-item-top-left">
                          <img :src="item.activityShareImagePath | logo_show" />
                        </div>
                        <div class="ticket-item-top-right">
                          <div>
                            <div class="title">{{item.title | dealLanguage(item.enTitle)}}</div>
                            <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                            <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                          </div>
                          <div class="price" v-if="item.price">{{'￥' | dealLanguage('$')}}{{item.price | amount_show}}</div>
                          <div class="price" v-else>{{'免费' | dealLanguage('FREE')}}</div>
                        </div>
                      </div>
                    </div>
                  </Radio>
                </RadioGroup>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
      <div class="btn-wrapper" v-if="currentTicket.id">
        <div class="info">
          <div class="info-p1">
            <span>{{'门票价格：' | dealLanguage('Ticket price: ')}}</span>
            <span v-if="currentTicket.price">{{'￥' | dealLanguage('$')}}{{currentTicket.price | amount_show}}</span>
            <span v-else>{{'免费' | dealLanguage('FREE')}}</span>
          </div>
          <div class="info-p2" v-if="currentTicket.price">{{'您需支付' | dealLanguage('You need to pay ')}}{{'￥' | dealLanguage('$')}}{{currentTicket.price | amount_show}}{{'用以支付当前门票' | dealLanguage(' for the current ticket.')}}</div>
          <div class="info-p2" v-else>{{'无需支付' | dealLanguage('No need to pay')}}</div>
        </div>
        <div class="btns">
          <div :class="['btn', buttonLoading && 'loading']" @click="submit" :loading="buttonLoading" v-if="language == 'zh'">
            <template v-if="!buttonLoading">
              <div class="btn-left" v-if="currentTicket.price">
                <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
                <span>微信支付</span>
              </div>
              <span v-else>获取门票</span>
            </template>
            <span v-else>Loading</span>
            <Icon type="ios-arrow-forward" />
          </div>
          <template v-else>
            <!-- <div :class="['btn', buttonLoading && 'loading']" :loading="buttonLoading" v-if="currentTicket.price">
              <template v-if="!buttonLoading">
                <div class="btn-left">
                  <img :src="static_img_url + 'pic/card-icon.png?v=' + $store.state.imgVersion" />
                  <span>Credit Card</span>
                </div>
              </template>
              <span v-else>Loading</span>
              <Icon type="ios-arrow-forward" />
            </div> -->
            <div :class="['btn', buttonLoading && 'loading']" @click="submitEn" :loading="buttonLoading">
              <template v-if="!buttonLoading">
                <img class="paypal-pay" :src="static_img_url + 'pic/paypal-icon.png?v=' + $store.state.imgVersion" v-if="currentTicket.price" />
                <span v-else>Get ticket now</span>
              </template>
              <span v-else>Loading</span>
              <Icon type="ios-arrow-forward" />
            </div>
          </template>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :default-index="defaultIndex" show-toolbar :columns="appMobileAreaCodeDtos" @confirm="onConfirm" @cancel="showPicker = false" value-key="name">
        <template #option="item">
          <div>+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showAddress" round position="bottom">
      <van-cascader v-model="currentAddressDto" :title="'请选择所在地区' | dealLanguage('Please Select')" :placeholder="'请选择' | dealLanguage('Select')" :options="addressDtos" :field-names="fieldNames" @close="showAddress = false" @finish="handleChangeAddress" />
    </van-popup>
  </div>
</template>
<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import TopTip from './topTip'
import { Agetmeta } from '@/service/app'
import {
  vbefGenOrder,
  orderStatus,
} from '@/service/vbef'
import buildTree from 'js/buildTree'
import { searchEntity } from 'js/searchEntity'
import { loginCommon } from '@/assets/js/login'
import { signUpMixins } from '@/assets/js/signUpMixins'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('预注册', 'Pre-registration'),
    }
  },
  inject: ['login', 'wxShare'],
  mixins: [searchEntity, loginCommon, signUpMixins],
  components: {
    PageHeader,
    TopTip
    // Treeselect,
  },
  created() {
    this.Agetmeta()
    this.getTicketList()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('预注册-CSGCT', 'Pre-registration-CSGCT'),
      linkurl: this.vbef_path + '/signUp',
    })
    // 判断是否微信浏览器
    if (this.isWeixinBrowser) {
      if (!this.$route.query.code && !this.wxCode) {
        let currentHref = `${this.index2_path}/home/wxMiddleware?language=${this.language}`
        currentHref = encodeURIComponent(currentHref)
        let link = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=${currentHref}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
        window.location.href = link
        return
      }
      if (this.$route.query.code) {
        this.wxCode = this.$route.query.code
      }
      this.checkAndInitBridge()
    } else {
      if (this.$route.query.pay_status) {
        this.payOrderId = this.$route.query.order_id
        this.orderStatus()
      }
    }
    this.pageLoading = false

    if (!this.user_key) {
      this.login(this.ininUserInfo)
    } else {
      this.ininUserInfo()
    }
  },
  beforeDestroy() {
    clearInterval(this.orderInv)
    // // 组件销毁前，移除事件监听器
    if (document.removeEventListener) {
      document.removeEventListener('WeixinJSBridgeReady', this.onBridgeReady)
    } else if (document.detachEvent) {
      document.detachEvent('WeixinJSBridgeReady', this.onBridgeReady)
      document.detachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
    }
  },
  data() {
    return {
      pageLoading: true,
      buttonLoading: false,
      wxCode: '',
      wxAppId: 'wx5f2bac5d4589997a',
      companyNatureTags: [],
      companyNatureTree: [],
      compNTother: '',
      tqList: Array(3).fill(1),
      currentForm: {
        name: '',
        compName: '',
        entityId: 0,
        department: '',
        title: '',
        email: '',
        addressId: '',
        companyProfile: '',
        companyprofileother: '',
        concurrent2: [],
        need2: [],
        need2other: '',
        service2: '',
        activityTicketName: '',
        activityTicketNameEn: '',
        mobile: '',
        mobileAreaCode: '86',
      },
      currentTicket: {},
      showAddress: false,
      orderInv: 0,
      payOrderId: '',
      showPicker: false,
      currentPartnerId: 0,
      currentPartner: {},
      defaultIndex: 0,
    }
  },
  computed: {
    fieldNames() {
      return {
        text: this.language == 'zh' ? 'name' : 'enName',
        value: 'id',
      }
    },
  },
  methods: {
    handleShowPicker() {
      this.showPicker = true
    },
    handleShowAddress() {
      this.showAddress = true
    },
    onConfirm(item) {
      this.currentForm.mobileAreaCode = item.mobileAreaCode
      this.showPicker = false
    },
    async Agetmeta() {
      let res = await Agetmeta({
        metaNameList: ['addressDtoList'],
      })
      if (res.code != 0) return
      this.$set(this.$data, 'addressDtoList', res.data.addressDtoList)
      const list =
        this.language == 'zh'
          ? res.data.addressDtoList
          : res.data.addressDtoList.filter((a) => a.gpid != 2287)
      this.addressDtos = buildTree(list)
      // this.$set(this.$data, 'companyNatureTags', res.data.companyNatureTags)
      // res.data.companyNatureTags.forEach((tag) => {
      //   tag.label = filter.dealLanguage(tag.name, tag.enName)
      // })
      // const tree = buildTree(res.data.companyNatureTags)
      // this.companyNatureTree = [...tree]
      // this.handleChangeNT(this.currentForm.companyNatureId, 1)
    },
    handleChangeAddress({ selectedOptions }) {
      this.showAddress = false
      this.currentForm.addressId = selectedOptions.length
        ? selectedOptions[selectedOptions.length - 1]['id'] + ''
        : ''
    },
    handleChangeCompanyProfile(value) {
      this.companyprofileother =
        value.indexOf('其他') > -1 || value.indexOf('Other') > -1 || value.indexOf('other') > -1
    },
    handleSeletTicket(value) {
      let item = this.ticketList.find((a) => a.id === value)
      this.currentTicket = { ...item }
    },
    submit() {
      // console.log(this.currentForm)
      if (this.buttonLoading) return
      if (!this.user_key) {
        this.login(this.ininUserInfo)
        return
      }
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true

          let { activityTicketId, ...params } = this.currentForm
          let ticketParamsStr = JSON.stringify(params)
          let pay_type = this.currentTicket.type == 1 ? 0 : this.isWeixinBrowser ? 1 : 2
          let order = await vbefGenOrder({
            activityTicketId: activityTicketId,
            checkFormJson: ticketParamsStr,
            payType: pay_type,
            loginPlatform: 9,
            openId: pay_type == 1 ? this.openId : '',
          })
          this.buttonLoading = false
          if (order.code == 0) {
            if (pay_type == 1) {
              this.payOrderId = order.data.activityOrderId
              this.invokeWeChatPay(order.data.jsapiResult)
            } else if (pay_type == 2) {
              let currentHref = `${this.vbef_path}/signUp?pay_status=1&order_id=${order.data.activityOrderId}`
              currentHref = encodeURIComponent(currentHref)
              window.location = order.data.wxPayMpOrderH5Url + `&redirect_url=${currentHref}`
            } else if (pay_type == 0) {
              this.$notify({
                type: 'success',
                message: filter.dealLanguage('报名成功！', 'Registration successful!'),
              })
              this.$router.push({
                name: 'ticketDetail',
                params: { id: order.data.activityTicketUserRelationId },
              })
            }
          } else {
            this.$notify(filter.dealLanguage(order.msg, order.enMsg || order.msg))
          }
        } else {
          this.$notify(
            filter.dealLanguage('请完善表单后提交', 'Please complete the form and submit it')
          )
        }
      })
    },
    async orderStatus() {
      let res = await orderStatus({
        id: this.payOrderId,
      })
      if (res.code == 0) {
        if (res.data.status == 2) {
          this.$notify({
            type: 'success',
            message: filter.dealLanguage('购买成功！', 'Purchase successful!'),
          })
          clearInterval(this.orderInv)
          this.$router.push({
            name: 'ticketDetail',
            params: { id: res.data.activityTicketUserRelationId },
          })
        }
      }
    },
    invokeWeChatPay(params) {
      if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            // 这些参数应由后端提供
            appId: this.wxAppId,
            timeStamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package: params.packageValue,
            signType: params.signType, // 或者其他签名方式，如"RSA"
            paySign: params.paySign,
          },
          (res) => this.handlePaymentResponse(res)
        )
      } else {
        // 处理WeixinJSBridge不可用的情况
        console.error('WeixinJSBridge is not available.')
      }
    },
    handlePaymentResponse(res) {
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 支付成功处理逻辑
        this.orderInv = setInterval(() => {
          this.orderStatus()
        }, 1000)
      } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        // 支付取消处理逻辑
        this.$notify(filter.dealLanguage('取消支付', 'Cancel payment'))
      } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
        // 支付失败处理逻辑
        this.$notify(filter.dealLanguage('支付失败，请重试', 'Payment failed, please try again'))
      } else {
        // 其他情况处理逻辑
        console.log('Unknown payment response.', res)
      }
    },
    onBridgeReady() {
      // WeixinJSBridge 已经准备好了，可以进行后续操作
      console.log('WeixinJSBridge is ready.')
      // 这里可以调用需要Bridge就绪后才能执行的方法，例如this.invokeWeChatPay()
    },
    checkAndInitBridge() {
      // 微信浏览器
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
        }
      } else {
        this.onBridgeReady()
      }
    },
  },
  watch: {
    need2other() {
      this.currentForm.need2other = ''
    },
    companyprofileother() {
      this.currentForm.companyprofileother = ''
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
@import '~styles/ticket-item-m.styl'
@import '~styles/sign-up-m.styl'
</style>